import React from 'react';
import {
  GuideContainer,
  GuideTitle,
  GuideDiagram,
  GuideLearnMore
} from './EntityTreeStructureGuide.styles';
import { ArrowLinkIcon } from '../../assets/icons';
import { ReactComponent as GuideDiagramSvg } from './guide-diagram.svg';

export const EntityTreeStructureGuide = ({ onLearnMore }) => {
  return (
    <GuideContainer>
      <GuideTitle>
        How to create entity tree structure?
        <GuideLearnMore onClick={onLearnMore}>
        <span>Learn more</span>
        <ArrowLinkIcon />
      </GuideLearnMore>
      </GuideTitle>
      <GuideDiagram>
        <GuideDiagramSvg />
      </GuideDiagram>
    </GuideContainer>
  );
}; 